
import Vue from 'vue';
import { CvButton } from '@carbon/vue';
import Close16 from '@carbon/icons-vue/es/close/16';

export default Vue.extend({
  components: { CvButton, Close16 },
  props: {
    headerTitle: {
      type: String,
      required: true,
    },
  },
});
